import React from "react";

import { faTimes } from "@awesome.me/kit-4c83d50d0d/icons/classic/light";
import {
	faCheckCircle,
	faExclamationTriangle,
	faInfoCircle,
	faTimesOctagon,
} from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import { IconButton } from "~/ui/legacyFellowIndex";

import styles from "./InlineBanner.module.css";

export const bannerIcons: Record<BannerVariant, IconDefinition> = {
	default: faInfoCircle,
	error: faTimesOctagon,
	warning: faExclamationTriangle,
	success: faCheckCircle,
};

type BannerVariant = "default" | "error" | "warning" | "success";

type InlineBannerProps = {
	variant?: BannerVariant;
	dismissible?: boolean;
	hideIcon?: boolean;
} & React.HTMLProps<HTMLDivElement>;

const InlineBanner = ({
	className,
	variant = "default",
	dismissible = false,
	hideIcon = false,
	children,
	...rest
}: InlineBannerProps) => {
	const [isVisible, setIsVisible] = React.useState(true);

	const handleDismiss = React.useCallback(() => {
		setIsVisible(false);
	}, []);

	const classNames = cx(styles.inlineBanner, styles[`variant-${variant}`], className);

	if (!isVisible) return null;

	return (
		<div {...rest} className={classNames}>
			{!hideIcon && <FontAwesomeIcon icon={bannerIcons[variant]} className={styles.inlineBannerIcon} />}
			<span className={styles.bannerContents}>{children}</span>
			{dismissible && <IconButton icon={faTimes} className={styles.dismissIcon} onClick={handleDismiss} />}
		</div>
	);
};

export default InlineBanner;
